import { useEffect } from 'react'
import { router, usePathname, useRootNavigationState } from 'expo-router'
import { useAdminPreview } from '@hooks/useAdminPreview'
import {
  isAdminViewRoute,
  isGuestRoute,
  isOptionalAuthRoute,
  toAdminViewPath,
} from '@utils/routes'

/**
 * Mantém produtor e aluno cada um do seu lado, espelhando o core: lá o
 * TMSController barra aluno em /admin_view (authenticate_admin_view) e barra
 * colaborador nas rotas de aluno (redirect_collaborator). Quando o nginx manda
 * a rota para o members, esses filtros deixam de rodar — a guarda precisa
 * existir aqui.
 *
 * Não é a barreira de segurança: essa é o GraphQL do core, que autoriza leitura
 * de curso por colaborador e escrita só por matrícula. Aqui é navegação.
 */
export function AdminPreviewRouter() {
  const { isPreview } = useAdminPreview()
  const pathname = usePathname()
  const rootNavigationState = useRootNavigationState()

  useEffect(() => {
    if (!rootNavigationState?.key) return
    if (isGuestRoute(pathname) || isOptionalAuthRoute(pathname)) return

    const inAdminView = isAdminViewRoute(pathname)

    if (isPreview && !inAdminView) {
      router.replace(toAdminViewPath(pathname))
      return
    }

    if (!isPreview && inAdminView) {
      router.replace('/')
    }
  }, [isPreview, pathname, rootNavigationState?.key])

  return null
}
